import { Component, OnInit,ViewEncapsulation,Input, Inject } from '@angular/core';
import { forkJoin } from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

import {MarketBetsService} from "../../services/market-bets.service";
import {TennisBetsService} from "../../services/tennis/tennis-bets.service";
import {SoccerBetsService} from "../../services/soccer/soccer-bets.service";
import {SessionBetsService} from "../../services/session-bets.service";
import {FancyBetsService} from "../../services/fancy-bets.service";
import {BookmakerBetsService} from "../../services/bookmaker-bets.service";

@Component({
  selector: 'app-bet-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
  //encapsulation: ViewEncapsulation.None, // Apply styles globally
})
export class BetListModelComponent implements OnInit {
  
  
  match_bets: any = [];
  tennis_bets: any = [];
  soccer_bets: any = [];
  session_bets: any = [];
  bookmaker_bets: any = [];
  fancy_bets: any = [];

  marge_bets: any = [];
  tabKeys: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,private matchBetService: MarketBetsService,private bookmakerBetsService: BookmakerBetsService,private fancyBetsService: FancyBetsService,private sessionBetsService: SessionBetsService, private tennisBetsService: TennisBetsService, private soccerBetService: SoccerBetsService) {
    this.tabKeys = Object.keys(this.data).filter(key => key !== 'type');
    this.tabKeys = this.tabKeys.filter(k => data[k].length > 0)
    console.log('tabkeys',this.tabKeys);
   }

  ngOnInit(): void {
    
    console.log('data---->',this.data);
    // this.getAllBets();
  }

  getAllBets() {
    forkJoin([
      this.matchBetService.getOpenBetsForMatch(),
      this.bookmakerBetsService.getOpenBetsForBookmaker(),
      this.sessionBetsService.getOpenBetsforSession(),
      this.fancyBetsService.getOpenBetsforFancy(),
      this.soccerBetService.getOpenBetsforSoccer(),
      this.tennisBetsService.getOpenBetsforTennis(),
    ]).subscribe({
      next: (responses: [any, any, any, any, any, any]) => {
        this.match_bets = responses[0];
        this.bookmaker_bets = responses[1];
        this.session_bets = responses[2];
        this.fancy_bets = responses[3];
        this.soccer_bets = responses[4];
        this.tennis_bets = responses[5];
  
        this.marge_bets = [
          ...(this.match_bets as any[]).map(item => ({ ...item, 'matchtype': 'icon-4', 'sport':'cricket' })),
          ...(this.bookmaker_bets as any[]).map(item => ({ ...item, 'matchtype': 'icon-4', 'sport':'cricket' })),
          ...(this.session_bets as any[]).map(item => ({ ...item, 'matchtype': 'icon-4', 'sport':'cricket' })),
          ...(this.fancy_bets as any[]).map(item => ({ ...item, 'matchtype': 'icon-4', 'sport':'cricket' })),
          ...(this.soccer_bets as any[]).map(item => ({ ...item, 'matchtype': 'icon-1', 'sport':'soccer' })),
          ...(this.tennis_bets as any[]).map(item => ({ ...item, 'matchtype': 'icon-2', 'sport':'tenni' })),
        ];
        console.log('matches',this.marge_bets);
      },
      error: (error) => {
        console.error('Error fetching bets:', error);
      },
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
